import { Link } from "react-router-dom"
import '../styles/footer.scss'

function Footer() {
  return (
    <div id="footer">
      <div id="footer-left">
        <Link to="/privacy-policy">Privay Policy</Link>
        <Link to="/terms-of-service">Terms of Service</Link>
      </div>

      <div id="footer-center">
        <span id="made-with-love">
          Made with <i className="bi bi-heart-fill"></i>
        </span>
      </div>

      <div id="footer-right">
        © HeyArt 2023
      </div>
    </div>
  )
}

export default Footer
